import api from "../../../api/api";

export const checkRootPermission = () => api.get("/root/check-root");
export const verifyRootAction2FA = (verificationCode) =>
  api.post("/root/2fa/google/verify-action", { verificationCode });
